export const FormatPayload = {
	numbers: {
		isDecimal: true,
		decimalAccuracy: 2,
		decimalSeparator: ',',

		isGrouped: true,
		groupSize: 3,
		groupSeparator: ' ',
		en: {
			decimalSeparator: ',',
			groupSeparator: ' ',
			GB: {
				decimalSeparator: '.',
				groupSeparator: ','
			}
		}
	},
	unit: {
		beforeAmount: false
	},
	currency: {
		isDecimal: true,
		beforeAmount: false
	},
	dates: {
		long: 'dd.mm.yyyy',
		fr: {
			long: 'dd/mm/yyyy'
		}
	}
};